import React from "react";
import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <section className="hero-modern" id="home">
      <div className="hero-content">
        <motion.div
          className="hero-badge"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="badge-icon">✦</span>
          <span>AI • Web • Mobile • Cloud • Games</span>
        </motion.div>

        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <span className="gradient-text">One Spark.</span>{" "}
          Infinite Possibilities.
        </motion.h1>

        <motion.p
          className="hero-tagline-seo"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          AI, Web &amp; Mobile App Development Company in India
        </motion.p>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          EmberByte builds custom websites, mobile apps, and AI-powered tools that help
          your business grow, save time, and reach more customers. You bring the
          idea—our team designs, develops, and launches it end to end.
        </motion.p>

        <motion.div
          className="hero-cta"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <motion.a
            href="#contact"
            className="cta-primary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Get Started
          </motion.a>
          <motion.a
            href="#services"
            className="cta-secondary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Our Services
          </motion.a>
        </motion.div>

        <motion.div
          className="hero-stats"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <div className="hero-stat">
            <span className="hero-stat-value gradient-text">15+</span>
            <span className="hero-stat-label">Technologies we build with</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-value gradient-text">6</span>
            <span className="hero-stat-label">Core service areas</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-value gradient-text">End&#8209;to&#8209;End</span>
            <span className="hero-stat-label">From idea to launch</span>
          </div>
          <div className="hero-stat">
            <span className="hero-stat-value gradient-text">24/7</span>
            <span className="hero-stat-label">Monitoring &amp; support</span>
          </div>
        </motion.div>

      </div>

      <motion.div
        className="hero-visual"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.4 }}
      >
        <div className="floating-card card-1">
          <div className="card-icon">🤖</div>
          <div className="card-text">AI Solutions</div>
        </div>
        <div className="floating-card card-2">
          <div className="card-icon">💻</div>
          <div className="card-text">Web Development</div>
        </div>
        <div className="floating-card card-3">
          <div className="card-icon">📱</div>
          <div className="card-text">Mobile Apps</div>
        </div>
        <div className="floating-card card-4">
          <div className="card-icon">☁️</div>
          <div className="card-text">Cloud Solutions</div>
        </div>
      </motion.div>
    </section>
  );
}
